// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".OtherPortalHeader[data-v-57d3b45d]{background:#fff;z-index:1;display:grid;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-transition:all .2s ease-out;transition:all .2s ease-out}.OtherPortalHeader[data-v-57d3b45d]  .header-text{font-size:24px!important;font-weight:300!important}.OtherPortalHeader[data-v-57d3b45d]  .header{margin-top:24px!important}", ""]);
// Exports
module.exports = exports;
